import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep';

const BuilderSubSectionTitle = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const autotranslate = props?.autotranslate ?? true;

	let title = props?.title ?? false;
	if(title === false) return null;
	
	const custom_title_content = props?.custom_title_content ?? false;
	const icon = props?.icon ?? false;
	const title_actions = props?.title_actions ?? false;
	const extra_actions = props?.extra_actions ?? false;
	const bordered = props?.bordered ?? true;
	let subtitle = props?.subtitle ?? false;

	if(autotranslate) {
		title = i18n(title);
		if(subtitle !== false && typeof(subtitle) == 'string') subtitle = i18n(subtitle);
	}

	const _class = props?._class ?? false;
	let classes = ['gui_section_header_builder'];
	if(_class !== false) classes.push(_class);
	if(!bordered) classes.push('is_not_bordered');

	return (
		<>
			<header class={classes.join(" ")}>
				{(!custom_title_content) ? (
					<h3 class={`section_title${(icon !== false) ? ` ${icon} with_icon` : ''}`} dangerouslySetInnerHTML={{ __html:title }} />
				) : (
					<h3 class={`section_title${(icon !== false) ? ` ${icon} with_icon` : ''}`}>{title}</h3>
				)}

				{(title_actions !== false) && (
					title_actions
				)}
			</header>

			{(extra_actions !== false) && (
				extra_actions
			)}

			{(subtitle !== false && typeof(subtitle) == 'string') && (
				<p class="gui_note_text" dangerouslySetInnerHTML={{ __html:subtitle }} />
			)}

			{(subtitle !== false && typeof(subtitle) == 'object') && (
				<div class="gui_note_text">{subtitle}</div>
			)}
		</>
	)
};

export default injectIntl(BuilderSubSectionTitle);